import React from 'react';
import { CURRENCY } from '../../../constants';
import { formatMoney } from '../../../services';

export default function ProductPrice({ promotionPrice, price, promotionName }) {
    return (
        <div className='flex horizontal-between vertical-center mt-25'>
            <div>
                {promotionPrice > 0 && promotionPrice < price ? (
                    <span className='price'>
                        <del>
                            <span>{`${CURRENCY.B}${formatMoney(price)}`}</span>
                        </del>
                        <ins>
                            <span className='ammount'>{`${CURRENCY.B}${formatMoney(promotionPrice)}`}</span>
                        </ins>
                    </span>
                ) : (
                        <span className='price'>
                            <ins>
                                <span className='ammount'>{`${CURRENCY.B}${formatMoney(price)}`}</span>
                            </ins>
                        </span>
                    )}
            </div>
            {
                promotionName && (
                    <div className='flex wrap horizontal-end'>
                        {
                            promotionName.map((item, index) => (
                                <div style={{ backgroundColor: '#db2828' }} className='label-promotion ml-10 mb-10' key={index}>
                                    {item}
                                </div>
                            ))
                        }
                    </div>
                )
            }
        </div>
    );
}
